import { get, post, put } from 'utils/methods';

export function getPaymentTypeApi(data, headers) {
    return get(`${process.env.REACT_APP_REST_ORDERS}payment-types`, data, headers);
}

export function addPaymentTypeApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/payment-type`, data, headers);
}

export function editPaymentTypeApi(data, headers) {
    return put(`${process.env.REACT_APP_REST_ORDERS}commands/payment-type`, data, headers);
}

export function updateTranslatePaymentTypeApi(data, headers) {
    return post(`${process.env.REACT_APP_REST_ORDERS}commands/payment-type/translate`, data, headers);
}
